import {
  GROUP_FILTERS_SOURCE_KEYS,
  getDefaultGroupFilterObjectShape,
  IGroupFilterItem,
  IGroupFilters, IFiltersOptions
} from '@/bundles/GroupFilters/helpers/getDefaultFiltersObj';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { GROUP_WITH_STANDALONE_FILTERS } from '@/bundles/GroupFilters/consts/groupWithStandaloneFilters';
import { Nullable } from '@/utils/types';

import * as constants from './filters-types';

export default {
  [constants.SET_FILTERS_FOR_GROUP] (state, { filters, source, groupId }: { filters: IGroupFilterItem, source: string, groupId: string }) {
    state[source].savedSetId = 'savedSet' in filters ? filters.savedSet.value : '';

    if ('savedSet' in filters) { // prevent savedSet from being saved in filters
      delete filters.savedSet;
    }

    const sourceFilters = state[source].filters;

    if (!isValuePresent(filters)) {
      delete sourceFilters[groupId];
      state[source].filters = { ...sourceFilters };
      return;
    }

    const shouldMergeWithFirstGroup = groupId === GROUP_WITH_STANDALONE_FILTERS &&
      !sourceFilters[GROUP_WITH_STANDALONE_FILTERS] &&
      Object.keys(sourceFilters).length >= 1;

    if (!shouldMergeWithFirstGroup) {
      sourceFilters[groupId] = { ...filters };
      state[source].filters = { ...sourceFilters }; // triggers reactivity
      return;
    }

    // merge standalone filters into the first group, preserving key order is important, to prevent chips swapping
    const existingGroupIds = Object.keys(sourceFilters);
    const firstGroupId = existingGroupIds[0];

    state[source].filters = existingGroupIds.reduce((acc, key) => {
      if (key === firstGroupId) {
        acc[GROUP_WITH_STANDALONE_FILTERS] = { ...sourceFilters[key], ...filters };
      } else {
        acc[key] = sourceFilters[key];
      }
      return acc;
    }, {});
  },
  [constants.SET_FILTERS] (state, { filters, source }: { filters: IGroupFilters, source: string }) {
    state[source].filters = { ...filters };
  },
  [constants.UPDATE_FILTERS_OPTIONS] (state, { options, source }: { options: IFiltersOptions, source: string }) {
    state[source].options = { ...options };
  },
  [constants.SET_SAVED_SET_ID] (state, { id, source }: { id: Nullable<string>, source: string }) {
    state[source].savedSetId = id;
  },
  [constants.SET_FILTER_NAME] (state, { filterName, type }: { filterName: Nullable<string>, type: string }) {
    state[type].filterName = filterName;
  },
  [constants.SET_FILTER_ID] (state, { filterId, type }: { filterId: Nullable<string>, type: string }) {
    state[type].filterId = filterId;
  },
  [constants.SET_SEARCH] (state, { search, type }: { search: Nullable<string>, type: string }) {
    state[type].keyword = search;
  },
  [constants.RESET_FILTER] (state, source: string) {
    state[source].filters = {};
  },
  [constants.SET_LAST_SELECTED_TYPE] (state, { source, type }: { source: string, type: Nullable<string> }) {
    state[source].lastSelectedType = type;
  },
  [constants.RESET_ALL_FILTERS] (state) {
    GROUP_FILTERS_SOURCE_KEYS.forEach(key => {
      state[key] = getDefaultGroupFilterObjectShape();
    });
  },
}
